module.exports = __webpack_public_path__ + "img/fishing.be5030ca.webp";